module.exports = __webpack_public_path__ + "img/page-background-color.2cfd582c.png";